import { IconPropsType } from '..';

export const BackofficeLogoutIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width="26"
      height="26"
      rx="2"
      fill="#23252A"
    />
    <path d="M13.0001 14.0324C13.4713 14.0324 13.8534 13.6625 13.8534 13.2065V7.4259C13.8534 6.9699 13.4713 6.6001 13.0001 6.6001C12.5289 6.6001 12.1468 6.9699 12.1468 7.4259V13.2065C12.1468 13.6633 12.5281 14.0324 13.0001 14.0324ZM16.9388 8.32423C16.5676 8.04448 16.0313 8.1073 15.7409 8.46616C15.4505 8.8259 15.5159 9.34436 15.8871 9.6259C17.0348 10.4943 17.6934 11.8001 17.6934 13.2065C17.6934 15.7105 15.5881 17.7485 13.0001 17.7485C10.4121 17.7485 8.30676 15.7098 8.30676 13.2065C8.30676 11.7993 8.96516 10.4943 10.1126 9.62461C10.4838 9.34307 10.5494 8.82461 10.2589 8.46487C9.96794 8.1059 9.4322 8.04319 9.061 8.32294C7.49716 9.50848 6.6001 11.2891 6.6001 13.2065C6.6001 16.6207 9.4721 19.4001 13.0001 19.4001C16.5281 19.4001 19.4001 16.6207 19.4001 13.2065C19.4001 11.2891 18.5041 9.50848 16.9388 8.32423Z" />
  </svg>
);
